import {
  React,
  useState,
  useEffect,
  useRef,
  PageStyle,
  QUICK_ADD,
  REDIRECT,
  Button,
  useTranslation,
  useRouter,
  PlusIcon,
} from "@/imports-files/components/quick-add";

function QuickAdd(props) {
  const { t } = useTranslation();
  const router = useRouter();
  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const session = props.session;
  const [isLoading, setLoading] = useState(true);

  function closeDropDown(setIsActive) {
    setTimeout(() => setIsActive(false), 50);
  }

  useEffect(() => {
    setLoading(false);

    const pageClickEvent = (e) => {
      // If the active element exists and is clicked outside of
      if (
        dropdownRef.current !== null &&
        !dropdownRef.current.contains(e.target)
      ) {
        setIsActive(!isActive);
      }
    };

    if (isActive) {
      window.addEventListener("click", pageClickEvent);
    }

    return () => {
      window.removeEventListener("click", pageClickEvent);
    };
  }, [isActive]);

  if (isLoading) {
    return "";
  }

  return (
    <div className={`Dpflex ${PageStyle.LinkAsButtons}`}>
      {QUICK_ADD.allowed_roles_add_team.includes(session?.role) &&
        !process.env.NEXT_PUBLIC_HEARTPACE && (
          <Button
            buttonstyle={`${PageStyle.secondarybtnborder} buttonWithIcon`}
            onClick={() => {
              closeDropDown(setIsActive);
              router.push(REDIRECT.client.company.add_members);
            }}
          >
            <PlusIcon />
            {t("button:add:team")}
          </Button>
        )}
         {session.role != "reviewer" && (
      <Button
        buttonstyle={`${PageStyle.secondarybtnborder} buttonWithIcon`}
        onClick={() => {
          closeDropDown(setIsActive);
          router.push(REDIRECT.client.candidates.add_candidate);
        }}
      >
        <PlusIcon />
        {t("button:add:candidate")}
      </Button>
         )}
      {session.role != "reviewer" && (
        <Button
          buttonstyle={PageStyle.primarybtn}
          onClick={() => {
            closeDropDown(setIsActive);
            // if (
            //   props?.data?.privacy_policy_created ||
            //   !props?.data ||
            //   !props?.setPrivacyPolicyModal
            // ) {
              router.push(REDIRECT.client.jobs.new);
            // } else {
            //   props.setPrivacyPolicyModal(true);
            // }
          }}
        >
          {t("button:create:job")}
        </Button>
      )}
    </div>
  );
}

export default QuickAdd;
